export const loanStatusText = {
  Booking: 'Booking',
  Proposal: 'Proposal',
  Void: 'Voided',
  New: 'New Quote in Progress'
};
